import { Injectable } from '@angular/core';
import { combineLatest, map, Observable } from 'rxjs';
import { OrderQuery } from '@modules/order/state/order-query';
import { ProcedureConfigurationService } from '@modules/order/services/procedure-configuration.service';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { IdName } from '@shared/models/id-name';
import { Maybe } from '@/types/globals';
import { ProcedureTypeService } from './procedure-type.service';
import { ScanLayersLockService } from '@shared/services/scan-layers-lock.service';
import { ResendScanService } from '@modules/rx-for-doctor/services/resend-scan.service';

@Injectable()
export class RxProcedureTypeControlFacade {
	procedureType$: Observable<Maybe<IdName>> = this.orderQuery.type$;
	procedureTypes$ = this.procedureConfigurationService.types$;
	isProcedureAndTypeReadOnly$ = combineLatest([
		this.shellQuery.isReadOnly$,
		this.scanLayersLockService.isScanLayersLocked$,
		this.scanLayersLockService.isDuplicatedCaseLocked$,
		this.resendScanService.isResendScanSubTypeLocked$
	]).pipe(
		map(
			([isReadOnly, isScanLayersLocked, isDuplicatedCaseLocked, isResendScanSubTypeLocked]) =>
				isReadOnly || isScanLayersLocked || isDuplicatedCaseLocked || isResendScanSubTypeLocked
		)
	);

	constructor(
		private readonly orderQuery: OrderQuery,
		private readonly procedureConfigurationService: ProcedureConfigurationService,
		private readonly shellQuery: ShellQuery,
		private readonly procedureTypeService: ProcedureTypeService,
		private readonly scanLayersLockService: ScanLayersLockService,
		private readonly resendScanService: ResendScanService
	) {}

	handleProcedureTypeChanged(procedureTypeId: number): Observable<boolean> {
		return this.procedureTypeService.handleProcedureTypeChanged(procedureTypeId);
	}
}
